import { Controller } from 'stimulus';

import $ from 'jquery';

require('select2/dist/css/select2');
require('select2-bootstrap-theme/dist/select2-bootstrap');

export default class extends Controller {
    static targets = ['form'];
    static values = {deviceId: String}

    toggleActive(event) { 
        const selectedValue = event.target.value; 
        fetch("/update_device_visibility", {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: this.deviceIdValue,
          is_active: selectedValue === "true"
        })
      })
    }
    connect() {
        $('.device-modalities').select2();
    }
}
